var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeServiceIcn3Svg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-service-icn_3.svg",
    clipPath: "url(#clip0_567_45870)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.8364 12.1977H21.2682V3.91376C21.2682 2.39035 20.0303 1.05713 18.4116 1.05713H3.46258C1.84388 1.05713 0.605957 2.39028 0.605957 3.91376V36.2873C0.605957 37.906 1.84388 39.1439 3.46258 39.1439H35.836C37.4548 39.1439 38.6927 37.906 38.6927 36.2873V15.054C38.6927 13.4353 37.4552 12.1977 35.8364 12.1977ZM6.605 37.2396V31.8122C6.605 31.3362 6.98577 30.8601 7.55713 30.8601H9.93736L9.93765 37.2396H6.605ZM15.1747 37.2396H11.8421V30.8602H14.2223C14.7936 30.8602 15.1745 31.3362 15.1745 31.8123L15.1747 37.2396ZM19.3642 37.2396H17.1743V31.8122C17.1743 30.1935 15.9364 28.9555 14.3176 28.9555H7.6526C6.03388 28.9555 4.79596 30.1935 4.79596 31.8122V37.2396H3.4631C2.98706 37.2396 2.51097 36.8588 2.51097 36.2874V3.91398C2.51097 3.34267 2.98703 2.96185 3.4631 2.96185H18.412C18.8882 2.96185 19.3642 3.34263 19.3642 3.91398V37.2396ZM36.7888 36.2874C36.7888 36.8588 36.3126 37.2396 35.8366 37.2396H21.2685V14.1025H35.8366C36.3126 14.1025 36.7888 14.5785 36.7888 15.0546V36.2874Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1257 7.5377H5.65196C5.08064 7.5377 4.69983 7.15691 4.69983 6.58555C4.69983 6.01424 5.0806 5.63342 5.65196 5.63342H16.1257C16.697 5.63342 17.0778 6.01421 17.0778 6.58555C17.0778 7.15688 16.697 7.5377 16.1257 7.5377Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.1257 12.2974H5.65196C5.08064 12.2974 4.69983 11.9166 4.69983 11.3452C4.69983 10.7739 5.0806 10.3931 5.65196 10.3931H16.1257C16.697 10.3931 17.0778 10.7738 17.0778 11.3452C17.0778 11.9165 16.697 12.2974 16.1257 12.2974Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.1257 17.0571H5.65196C5.08064 17.0571 4.69983 16.6763 4.69983 16.1049C4.69983 15.5335 5.0806 15.1528 5.65196 15.1528H16.1257C16.697 15.1528 17.0778 15.5335 17.0778 16.1049C17.0778 16.6763 16.697 17.0571 16.1257 17.0571Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.1257 21.8167H5.65196C5.08064 21.8167 4.69983 21.4359 4.69983 20.8646C4.69983 20.2933 5.0806 19.9124 5.65196 19.9124H16.1257C16.697 19.9124 17.0778 20.2933 17.0778 20.8646C17.0778 21.4356 16.697 21.8167 16.1257 21.8167Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.2197 18.9545H23.746C23.1747 18.9545 22.7938 18.5738 22.7938 18.0024C22.7938 17.431 23.1747 17.0502 23.746 17.0502H34.2197C34.7911 17.0502 35.1718 17.431 35.1718 18.0024C35.1718 18.5738 34.7911 18.9545 34.2197 18.9545Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M34.2197 23.7222H23.746C23.1747 23.7222 22.7938 23.3414 22.7938 22.77C22.7938 22.1986 23.1747 21.8179 23.746 21.8179H34.2197C34.7911 21.8179 35.1718 22.1986 35.1718 22.77C35.1718 23.3414 34.7911 23.7222 34.2197 23.7222Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.2197 28.4819H23.746C23.1747 28.4819 22.7938 28.1011 22.7938 27.5297C22.7938 26.9585 23.1747 26.5776 23.746 26.5776H34.2197C34.7911 26.5776 35.1718 26.9585 35.1718 27.5297C35.1718 28.1011 34.7911 28.4819 34.2197 28.4819Z",
    fill: "black",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_567_45870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.7789,
    height: 39.9908,
    fill: "white",
    transform: "translate(0 0.00457764)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeServiceIcn3Svg);
export default __webpack_public_path__ + "static/media/home-service-icn_3.svg.3328d913ed40ab55fcb1867a7f1ec73b.svg";
export { ForwardRef as ReactComponent };